import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

import { ValStorageService } from './val-storage.service';
import { ValService } from './val.service';

@Injectable()
export class ValCategoryLookupResolver implements Resolve<boolean> {
    constructor(
        private _service: ValService,
        private _storage: ValStorageService,
        private _r: Router,
        private _ar: ActivatedRoute
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this._service.getCategoriesLookup()
            .pipe(
                take(1),
                map(data => {
                    this._storage.categories = data;
                    return true;
                }),
                catchError(err => {
                    this._r.navigate(['login'], { relativeTo: this._ar });
                    return of(null);
                })) as Observable<boolean>;
    }
}
